import { useState, useEffect, useRef } from "react";
import styles from "./Navbar.module.scss";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { logOut } from "../../redux/actions/auth/authActions";
import { saveLoading } from "../../redux/actions/loadingState/loadingStateActions";
import { useHistory, useLocation } from "react-router-dom";
import bell from "../../assets/images/myImages/bell.webp";
import down from "../../assets/images/myImages/down.webp";
import userIcon from "../../assets/images/myImages/user.webp";
import { useDispatch, useSelector } from "react-redux";
// import SearchIcon from "../../assets/images/search.svg";
import { ReactComponent as MonitorIcon } from "../../assets/images/monitor.svg";
import { ReactComponent as ExternalLink } from "../../assets/images/external-link.svg";
import useOnClickOutside from "../../util/clickOutside";
import { Divider } from "@material-ui/core";

const NavBar = ({ name, padding, margin, top }: any) => {
	const [profileModal, setProfileModal] = useState(false);
	const [monitor, setMonitor] = useState<boolean>(false);
	const [monitorDropDown, setMonitorDropDown] = useState<boolean>(false);
	const ref = useRef<any>();

	const history = useHistory();
	const dispatch = useDispatch();
	const { pathname } = useLocation();

	const handleProfileModal = () => {
		setProfileModal(true);
	};
	const handleProfileModalClose = () => {
		setProfileModal(false);
	};

	const handleMonitorModalOpen = () => {
		setMonitorDropDown(!monitorDropDown);
	};

	const handleMonitorModalClose = () => {
		setMonitorDropDown(false);
	};

	useOnClickOutside(ref, () => setMonitorDropDown(false));

	const signOutHandler = () => {
		localStorage.clear();
		dispatch(logOut());
		history.push("/signIn");
		dispatch(saveLoading(false));
		handleProfileModalClose();
	};

	const { user } = useSelector((state) => state?.authPayReducer?.auth);
	//mail shortener...
	const emailCut = user?.email?.slice(0, 20);

	let getInitials = function (string: string) {
		var names = string.split(" "),
			initials = names[0].substring(0, 1).toUpperCase();

		if (names.length > 1) {
			initials += names[names.length - 1].substring(0, 1).toUpperCase();
		}
		return initials;
	};
	useEffect(() => {
		if (pathname === "/") {
			setMonitor(true);
		} else {
			setMonitor(false);
		}
	}, [pathname]);

	return (
		<>
			<div className={styles.header} style={{ padding: padding }} ref={ref}>
				<h1 className={styles.navTitle} ref={ref}>
					{name}
				</h1>
				<div className={styles.inbox_con}>
					<div style={{ position: "relative" }} ref={ref}>
						{monitor ? (
							<div
								className={styles.monitorSelect}
								onClick={() => handleMonitorModalOpen()}
							>
								<MonitorIcon
									width={17}
									height={17}
									style={{ marginRight: "4px" }}
								/>
								<span>Monitor</span>
								<img
									src={down}
									className={styles.down}
									alt=""
									style={{ width: "8px", height: "4px", marginLeft: "4px" }}
								/>
							</div>
						) : null}

						{monitorDropDown !== false && (
							<>
								<div
									className={styles.blur}
									onClick={() => handleMonitorModalClose()}
									// onBlur={handleMonitorModalClose}
								>
									<div className={styles.monitorModal}>
										<p
											onClick={() => {
												window.open("/monitor-servers", "_blank");
											}}
										>
											Monitor Server{" "}
											<ExternalLink
												style={{
													marginLeft: "10px",
												}}
											/>
										</p>
										<Divider />
										<p
											onClick={() => {
												window.open("/monitor-transactions", "_blank");
											}}
										>
											Monitor Transactions{" "}
											<ExternalLink
												style={{
													marginLeft: "10px",
												}}
											/>
										</p>
									</div>
								</div>
							</>
						)}
					</div>

					{/* <img src={bell} alt="bell" /> */}
					<div className={styles.detail} onClick={handleProfileModal}>
						<img src={userIcon} alt="" />
						<img src={down} className={styles.down} alt="" />
					</div>
					{profileModal && (
						<>
							<div
								className={styles.blurClose}
								onClick={handleProfileModalClose}
							></div>
							<div className={styles.profile_modal} style={{ top: top }}>
								<div className={styles.profile_top}>
									<h2>ITEX Integrated Services</h2>
									<a href="" onClick={signOutHandler}>
										Sign Out
									</a>
								</div>
								<div className={styles.user}>
									<div className={styles.prefix}>
										{getInitials(`${user.firstname} ${user.lastname}`)}
									</div>
									<div className={styles.user_info}>
										<h6>
											{user.firstname} {user.lastname}
										</h6>
										<p>{`${emailCut}...`}</p>
										<div
											className={styles.view_acc}
											onClick={() => history.push("/account")}
										>
											View account{" "}
											<ArrowForwardIosIcon className={styles.icon} />
										</div>
									</div>
								</div>
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
};
export default NavBar;
